import React, { useState } from 'react';
import { Form, Button, Card, Row, Col } from 'react-bootstrap';
import { User } from 'firebase/auth';
import { db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';

interface PpfCalculatorProps {
  currentUser: User | null;
}

const PpfCalculator: React.FC<PpfCalculatorProps> = ({ currentUser }) => {
  const [yearlyInvestment, setYearlyInvestment] = useState<number>(150000);
  const [timePeriod, setTimePeriod] = useState<number>(15);
  const [interestRate] = useState<number>(7.1); // Current PPF interest rate
  const [result, setResult] = useState<any>(null);

  const calculatePpf = () => {
    let balance = 0;
    let totalInvestment = 0;
    for (let i = 0; i < timePeriod; i++) {
      totalInvestment += yearlyInvestment;
      balance = (balance + yearlyInvestment) * (1 + interestRate / 100);
    }

    setResult({
      totalInvestment: totalInvestment.toFixed(2),
      maturityValue: balance.toFixed(2),
      totalInterest: (balance - totalInvestment).toFixed(2),
    });
  };

  return (
    <Card className="p-4 shadow-sm">
      <h4 className="mb-4 text-center">PPF Calculator</h4>
      <Form>
        <Form.Group as={Row} className="mb-3">
          <Form.Label column sm={5}>Yearly Investment (₹)</Form.Label>
          <Col sm={7}>
            <Form.Control
              type="number"
              value={yearlyInvestment}
              onChange={(e) => setYearlyInvestment(parseFloat(e.target.value))}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} className="mb-3">
          <Form.Label column sm={5}>Time Period (Years)</Form.Label>
          <Col sm={7}>
            <Form.Control
              type="number"
              value={timePeriod}
              onChange={(e) => setTimePeriod(parseFloat(e.target.value))}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} className="mb-3">
          <Form.Label column sm={5}>Interest Rate (%)</Form.Label>
          <Col sm={7}>
            <Form.Control type="number" value={interestRate} readOnly disabled />
          </Col>
        </Form.Group>

        <div className="text-center">
          <Button variant="primary" onClick={calculatePpf}>
            Calculate Maturity Value
          </Button>
          {currentUser && result && (
            <Button variant="secondary" onClick={async () => {
              try {
                await addDoc(collection(db, `users/${currentUser.uid}/savedCalculations`), {
                  calculatorType: 'ppf',
                  yearlyInvestment,
                  timePeriod,
                  interestRate,
                  result,
                  timestamp: new Date(),
                });
                alert('PPF calculation saved!');
              } catch (e) {
                console.error('Error saving document: ', e);
                alert('Error saving calculation.');
              }
            }} className="ms-2">
              Save Calculation
            </Button>
          )}
        </div>

        {result && (
          <div className="mt-4">
            <h5 className="text-center">PPF Projection</h5>
            <Row>
              <Col><strong>Total Investment:</strong></Col>
              <Col className="text-end">₹{result.totalInvestment}</Col>
            </Row>
            <Row>
              <Col><strong>Total Interest:</strong></Col>
              <Col className="text-end">₹{result.totalInterest}</Col>
            </Row>
            <Row>
              <Col><strong>Maturity Value:</strong></Col>
              <Col className="text-end">₹{result.maturityValue}</Col>
            </Row>
          </div>
        )}
      </Form>
    </Card>
  );
};

export default PpfCalculator;
